/*!
 * Main frontend JavaScript of EXT:sitepackage
 *
 * (c) Earlybird GmbH <typo3@earlybird.at>
 *
 * For the full copyright and license information, please read the
 * LICENSE file that was distributed with this source code.
 */

// ToTop button
const toTopBtn = document.getElementById('btn-back-to-top');
if (toTopBtn) {
  // Show the button once the user has scrolled down 20px
  const scrollFunction = (): void => {
    const scrolled = document.body.scrollTop > 20 || document.documentElement.scrollTop > 20;
    toTopBtn.style.display = scrolled ? 'block' : 'none';
  };
  window.addEventListener('scroll', scrollFunction);
  scrollFunction();

  // Scroll to the top of the document on click
  toTopBtn.addEventListener('click', () => {
    window.scrollTo({top: 0, behavior: 'smooth'});
  });
}

//
// Navbar menu
//
function openNav(): void {
  document.getElementById('nav')?.setAttribute('aria-hidden', 'false');
}
function closeNav(): void {
  document.getElementById('nav')?.setAttribute('aria-hidden', 'true');
}
function dropdownMenuBlock(): void {
  const menu = document.getElementById('dropdown-menu');
  if (menu) {
    menu.style.display = 'block';
  }
}
function dropdownMenuNone(): void {
  const menu = document.getElementById('dropdown-menu');
  if (menu) {
    menu.style.display = 'none';
  }
}

// Keep the legacy global contract of the former non-bundled script
Object.assign(window, {openNav, closeNav, dropdownMenuBlock, dropdownMenuNone});

// Escape key closes the navbar menu
const navEl = document.getElementById('nav');
if (navEl) {
  navEl.addEventListener('keydown', (e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      closeNav();
      dropdownMenuNone();
    }
  });
}

//
// Progressive enhancement for collapsible elements
// #accessibility #progressiveEnhancement
//
const collapsibleToggles = document.querySelectorAll('.text-accordion [data-toggle="collapse"]');
const collapsibleBodies = document.querySelectorAll('.text-accordion .collapse.show');

if (collapsibleToggles.length > 0 && collapsibleBodies.length > 0) {
  collapsibleToggles.forEach((toggle) => {
    toggle.setAttribute('aria-expanded', 'false');
    toggle.classList.add('collapsed');
  });
  collapsibleBodies.forEach((element) => {
    element.classList.remove('show');
  });
}

//
// Set aria-hidden for the user nav button/span according to screen size
// Mobile = show span as label above visible subnav
// Desktop = show button as toggle for dropdown
// #accessibility
//
const usernavLabelSpan = document.querySelector('[data-usernav-label="text"]');
const usernavLabelButton = document.querySelector('[data-usernav-label="button"]');

function setUsernavLabelAttributes(): void {
  if (!usernavLabelSpan || !usernavLabelButton) {
    return;
  }
  if (window.innerWidth >= 992) {
    // Desktop
    usernavLabelSpan.setAttribute('aria-hidden', 'true');
    usernavLabelButton.setAttribute('aria-hidden', 'false');
  } else {
    // Mobile
    usernavLabelSpan.setAttribute('aria-hidden', 'false');
    usernavLabelButton.setAttribute('aria-hidden', 'true');
  }
}

if (usernavLabelSpan && usernavLabelButton) {
  setUsernavLabelAttributes();

  let resizeId: ReturnType<typeof setTimeout>;
  window.addEventListener('resize', () => {
    clearTimeout(resizeId);
    resizeId = setTimeout(setUsernavLabelAttributes, 500);
  });
}
